<template>
  <div :class="statisticCardStyleClass" @click="handleItemClick(result.type)">
    <div :class="valueStyleClass">
      {{ result.value }}
    </div>
    <div class="title">
      {{ result.title }}
    </div>
    <div class="navigation">
      {{ navigationText }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    type() {
      return this.result.type
    },
    isValueEmpty() {
      return this.result.value === 0
    },
    navigationText() {
      if (this.type === "un_billed") {
        return "สร้างใบแจ้งหนี้ >>>"
      }
      return "ดูรายละเอียด >>>"
    },
    valueStyleClass() {
      if (this.type === "rejected") {
        return `value ${this.type}`
      }
      return "value"
    },
    statisticCardStyleClass() {
      return `statistic-card view-detail ${this.type}`
    },
  },
  methods: {
    handleItemClick(status) {
      if (this.type === "un_billed" && this.isValueEmpty) {
        this.$message.error("ไม่มีนัดหมายสำหรับวางบิล")

        return
      }

      this.$emit("onItemClick", status)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.statistic-card {
  justify-content: center;
  display: flex;
  flex-direction: column;
  min-height: 160px;
  padding: 16px;
  border-radius: 8px;
}

.view-detail {
  cursor: pointer;
}

.view-detail:hover,
.view-detail:focus {
  opacity: 0.7;
}

.value {
  font-size: 36px;
  color: $black;
}

.title {
  font-size: 16px;
  color: #00000090;
  line-height: 0.9;
}

.navigation {
  font-size: 14px;
  color: #0000009b;
  margin-top: auto;
  margin-left: auto;
  font-weight: 600;
}

.un_billed {
  background-color: #fbcb0c20;
}

.in_progress {
  background-color: #aa43d220;
}

.rejected {
  background-color: #ffbfbf;
}

.transferred {
  background-color: #31b5a620;
}

.default {
  background-color: #f5f5f490;
}

@media (max-width: ($m-size - 1)) {
  .statistic-card {
    min-height: 110px;
    padding: 12px;
  }

  .value {
    font-size: 28px;
  }

  .title {
    font-size: 14px;
    line-height: 0.7;
  }

  .navigation {
    font-size: 12px;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .statistic-card {
    min-height: 110px;
    padding: 12px;
  }

  .value {
    font-size: 28px;
  }

  .title {
    font-size: 14px;
    line-height: 0.7;
  }

  .navigation {
    font-size: 12px;
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .statistic-card {
    min-height: 130px;
  }

  .value {
    font-size: 32px;
  }

  .title {
    font-size: 14px;
    line-height: 0.8;
  }

  .navigation {
    font-size: 12px;
  }
}
</style>
